import { z } from "zod";

export const ButtonVariantSchema = z.union([z.literal("contained"), z.literal("outlined")]);
